export default __webpack_public_path__ + "1f0de855348c55a0f407b8b8492ad019.png";